module.exports = __webpack_public_path__ + "static/media/nu.c44bab22.svg";